import {
  BankFeedAccountLinkingData,
  INITIAL_ACCOUNT_LENGTH,
} from "./constants";
import { GenericBankFeedsButton } from "./GenericBankFeedsButton";
import ScrollableComponent from "./ScrollableComponent";
import {
  getFormattedBankFeedAccounts,
  trackAmplitudeEvent,
} from "./utils/shared";

export const GenericBankFeedsLinkStepTwoAlternateComponent = ({
  setStep,
  confirmedBankFeedAccountLinkingData,
}: {
  setStep: (value: number) => void;
  setErrorMessage: (value: string) => void;
  setTransactionStartDate: (value: string) => void;
  confirmedBankFeedAccountLinkingData: BankFeedAccountLinkingData[];
}) => {
  const confirmHandler = () => {
    trackAmplitudeEvent("Confirming account links", {
      accountLinkingData: confirmedBankFeedAccountLinkingData,
    });
    setStep(3);
  };

  return (
    <>
      <div className="pt-4 pr-12 pl-12">
        <div className="text-sm" style={{ textAlign: "center", fontSize: 10 }}>
          STEP TWO
        </div>
        <div className="text-lg font-bold pb-2" style={{ textAlign: "center" }}>
          Confirm the following accounts should be linked.
        </div>
        <div className="text-sm" style={{ textAlign: "center" }}>
          We’ll begin pulling transactions from these accounts once linking is
          complete.
        </div>
      </div>
      <div style={{ minHeight: 340 }}>
        <div
          className="m-3"
          style={{
            border: "2px solid lightgray",
            borderRadius: "8px",
            position: "relative",
            minHeight: 170,
          }}>
          <ScrollableComponent
            minHeight={52}
            maxHeight={210}
            classStr="m-1"
            scrollable={
              confirmedBankFeedAccountLinkingData.length >
              INITIAL_ACCOUNT_LENGTH
            }>
            {getFormattedBankFeedAccounts(confirmedBankFeedAccountLinkingData)}
          </ScrollableComponent>
          <div className="pt-4 pb-4 pl-2 pr-2">
            <div
              className="font-bold"
              style={{ textAlign: "left", fontSize: 13 }}>
              We'll pull all transactions from your selected accounts.
            </div>
            <div style={{ textAlign: "left", fontSize: 12 }}>
              The available window for historical transactions may be limited by
              your financial institution.
            </div>
          </div>
        </div>
      </div>
      <GenericBankFeedsButton
        text="Confirm"
        onClick={confirmHandler}
        disabled={false}
      />
    </>
  );
};
